<template>
    <div class="wrapper-div-vce">
        <Paper class="paper-wrapper">
            <div class="leave-wrapper">
                <BaseButton class="leave-btn" variant="primary" @click="leaveChat">
                    <BaseIcon class="icon phone-icon-rotate" name="phone" />
                    End call
                </BaseButton>
            </div>
            <div v-if="loaded && !userLoading()" class="video-wrapper-vce">
                <iframe
                    class="wb-frame"
                    :src="wherebyUrl()"
                    allow="camera; microphone; fullscreen; speaker; display-capture"
                ></iframe>
            </div>
            <div class="new-invites">
                <div v-if="newInvites.length" class="new-invites">
                    <div v-if="videoChatAction === 'invited'">
                        <div class="incoming-head">
                            <BaseIcon class="video-icon" name="video" />
                            Incoming <strong>NEW</strong> video call ...
                        </div>
                    </div>
                    <div v-for="(item, index) in newInvites" :key="index">
                        <div class="new-invite-wrapper">
                            <div class="avatar-wrapper">
                                <div
                                    class="avatar-inner"
                                    :style="{ backgroundColor: stringToColor(item.videoChatID) }"
                                >
                                    <div
                                        v-if="item.fromAvatar"
                                        :style="{
                                            backgroundImage:
                                                'url(\'' + item.fromAvatar + '/small.jpg\')',
                                        }"
                                        class="avatar"
                                    ></div>
                                    <div v-else style="display:flex;align-items:center;">
                                        <BaseIcon class="icon-extra" name="user" />
                                    </div>
                                </div>
                            </div>
                            <div class="new-invite-name">
                                {{ item.fromName }}
                            </div>
                            <div>
                                <div class="deny-btn btn-wrapper">
                                    <div
                                        class="btn-primary btn round-btn"
                                        @click="() => closeVideoChatByID(item.videoChatID)"
                                    >
                                        <BaseIcon
                                            class="icon-extra phone-icon-rotate"
                                            name="phone"
                                            size="xs"
                                        />
                                    </div>
                                    <div class="btn-label">Decline</div>
                                </div>
                            </div>
                            <div>
                                <div class="accept-btn btn-wrapper">
                                    <div
                                        class="btn-primary btn round-btn"
                                        @click="() => joinChatByID(item.videoChatID)"
                                    >
                                        <BaseIcon class="icon-extra" name="video" size="xs" />
                                    </div>
                                    <div class="btn-label">Accept (Will close on-going call)</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Paper>
    </div>
</template>

<script>
import DialogService from '~/services/DialogService';
import stringToColor from '~/utils/stringToColor';

export default {
    name: 'VideoChatEmbedDialog',

    props: {
        videoChatAction: String,
        videoChatID: String,
    },
    data() {
        return {
            videoChatData: {},
            loaded: false,
            newInvites: [],
        };
    },
    computed: {
        user() {
            return this.$interfaces.user.me.get({ reactive: true });
        },
    },
    methods: {
        joinChat(item) {
            localStorage.setItem('wb_current_video_chat', item.videoChatID);
            DialogService.openVideoChatDialog({
                videoChatAction: item.videoChatAction,
                videoChatID: item.videoChatID,
            });
        },
        leaveChat() {
            localStorage.removeItem('wb_current_video_chat');
            this.$interfaces.dialogModal.getState().resolver.res();
        },
        userData() {
            return this.user.data;
        },
        userLoading() {
            return this.user.loading;
        },
        getFullName() {
            const user = this.userData() || {};
            return (user.firstName || '') + ' ' + (user.lastName || '');
        },
        params(data) {
            if (!data) return '';
            return data.map(item => `${item.key}=${encodeURIComponent(item.value)}`).join('&');
        },
        wherebyUrl() {
            if (this.videoChatData) {
                /*
                ==AVAILABLE PARAMETERS==
                video: string; // off
                audio: string; // off
                screenshare: string; // on|off
                recording: string; // on|off
                chat: string; // on|off
                people: string; // on|off
                leaveButton: string; // on|off
                displayName: string; // name
                background: string; // off
                */
                const params = [
                    {
                        key: 'iframeSource',
                        value: 'highered',
                    },
                    {
                        key: 'video',
                        value: 'off',
                    },
                    {
                        key: 'displayName',
                        value: this.getFullName(),
                    },
                ];
                let url = this.videoChatData.url.concat('?embed&', this.params(params));
                return url;
            }
            return '';
        },
        stringToColor(str) {
            return stringToColor(str);
        },
        closeVideoChatByID(id) {
            let index = this.newInvites.findIndex(item => item.videoChatID === id);
            if (index >= 0) {
                this.newInvites.splice(index, 1);
            }
        },
        joinChatByID(id) {
            localStorage.setItem('wb_current_video_chat', id);
            DialogService.openVideoChatDialog({
                videoChatAction: 'invited',
                videoChatID: id,
            });
        },
    },
    mounted() {
        this.$interfaces.communication['video-chat'].room.byid
            .video_chat_id(this.videoChatID)
            .get({ forceUpdate: true })
            .then(res => {
                this.videoChatData = res.data;
            })
            .finally(() => {
                this.loaded = true;
            });
        this.$root.$on('video-chat-new-invite', data => {
            this.newInvites.push(data);
        });
    },
};
</script>

<style lang="css" scoped>

.paper-wrapper {
    padding:15px;
}

.wrapper-div-vce {
    padding:15px;
    width: 80%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
}

@media only screen and (max-width: 600px) {
    .wrapper-div-vce {
        width:100%;
    }
}
.video-wrapper-vce {
    height: calc(80vh + 20px);
    width: 100%;
}
.wb-frame {
    width: 100%;
    height: 80vh;
    border:0;
    border-radius: 5px;
}

.leave-wrapper {
    width:100%;
    position:relative;
    height:50px;
}

.leave-btn {
    right:0;
    position:absolute;
    height:38px;
    background-color: #E83C24 !important;
}

.icon {
    font-size: 30px;
    color: white;
    display:inline-block !important;
    vertical-align: top;
    margin-top: -12px;
}

.phone-icon-rotate {
    transform: rotate(calc(180deg + 45deg)); /* Hack rotating the phone icon to lay down */
}






.video-icon {
    display: inline !important;
    font-size: 20px;
}

.incoming-head {
    text-align:center;
    margin-bottom:10px;
}

.avatar {
    width: 100%;
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}

.accept-btn .round-btn {
    background-color: #4EC430 !important;
}

.deny-btn .round-btn {
    background-color: #E83C24 !important;
}

.icon-extra {
    font-size: 30px;
    color: white;
}

.new-invite-wrapper {
    border: 1px solid var(--gray);
    border-radius: 10px;
    padding: 10px;
    display:grid;
    grid-template-columns: 1fr 2fr 1fr 1fr;
    grid-gap:5px;
    align-items:center;
    justify-items:center;
    max-width:800px;
    margin-left:auto;
    margin-right:auto;
    margin-bottom:5px;
}

.new-invite-wrapper .avatar-wrapper {
    padding:0;
    text-align:center;
}

.new-invite-wrapper .avatar-inner {
    margin: 0;
    width:40px;
    height:40px;
    font-size: 100%;
    border-radius: 50%;
    box-shadow: var(--shadow);
    overflow: hidden;
    display: flex;
    justify-content: center;
    margin-left:auto;
    margin-right:auto;
    margin-bottom:10px;
}

.new-invite-wrapper .round-btn {
    height: 40px;
    width: 40px;
    font-size: 100%;
    display: flex;
    justify-content: center;
    border-radius: 50%;
    border: 0;
    cursor: pointer;
}

.new-invite-wrapper .btn-label {
    font-size: 10px;
}

.new-invite-wrapper .btn-wrapper {
    text-align: center;
    align-items: center;
    display: flex;
    flex-direction: column;
}

.new-invite-name {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
}
</style>
